import packingRequest from "../request/packing"

const apiRequest = packingRequest()

export const getNextBoxDiary = (payload) => {
    return apiRequest({
        url: `/packing/boxes/diary/search`,
        method: 'POST',
        data: payload,
    })
}

export const exportNextBoxDiary = (payload) => {
    return apiRequest({
        url: `/packing/boxes/diary/export-ggsheet`,
        method: 'POST',
        data: payload,
    })
}

export const exportNextBoxDiaryItems = (payload) => {
    return apiRequest({
        url: `/packing/boxes/diary/export-items-to-ggsheet`,
        method: 'POST',
        data: payload,
    })
}

export const getNextBoxDiaryDetails = (id) => {
    return apiRequest({
        url: `/packing/boxes/diary/${id}`,
        method: 'GET',
    })
}

export const noteNextBoxDiary = (id, payload) => {
    return apiRequest({
        url: `/packing/boxes/diary/${id}/note`,
        method: 'PUT',
        data: payload,
    })
}

export const deleteNextBoxFromDiary = (id, payload) => {
    return apiRequest({
        url: `/packing/boxes/diary/move-boxes/${id}`,
        method: 'DELETE',
        data: payload,
    })
}

export const updateNextBoxFromDiary = (id, payload) => {
    return apiRequest({
        url: `/packing/boxes/diary/move-boxes/${id}`,
        method: 'POST',
        data: payload,
    })
}

export const moveNextBoxFromDiary = (payload) => {
    return apiRequest({
        url: `/packing/boxes/diary/move-boxes`,
        method: 'POST',
        data: payload,
    })
}